import PropTypes from 'prop-types';
import React from 'react';
import { ThemeProvider } from 'react-css-themr';
import { Tab, Tabs } from 'react-toolbox';
import { stringifyList } from '../../../../../utils';
import UserDetailsCard from 'components/users/UserDetailsCard';
import UserDetailsBasicInfo from 'components/users/UserDetailsBasicInfo';
import UserDetailsBadgeInfo from 'components/users/UserDetailsBadgeInfo';
import UserDetailsRow from 'components/users/UserDetailsRow';
import UserDetailsElement from 'components/users/UserDetailsElement';
import TimeOffTable from 'components/TimeOffTable';
import { EditToggleButton } from 'components/EditableTable';
import { can } from '../../../../../services';

import IQMType from 'types/iqm';
import PTOType from 'types/pto';
import { RoleType } from 'types/user';

import RTTabs from 'styles/tabs';

const detailsTheme = {
  RTTabs,
};

const TIME_OFF_TAB = 1;

class IQMDetailsCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isEditable: false };
  }

  handleEditToggle = () => {
    const isEditable = !this.state.isEditable;
    this.setState({ isEditable });
  }

  renderTimeOffEditButton = () => {
    const { role, user, iqm } = this.props;
    if (!can(role, 'manage', 'pto', { user_id: user.id, obj_id: iqm.user_id })) return null;

    const { isEditable } = this.state;
    return <EditToggleButton actionLabel="Edit Time Off" isEditable={isEditable} onClick={this.handleEditToggle} />;
  }

  render() {
    const { isEditable } = this.state;
    const { iqm, role, ptos, activeTab, onTabChange } = this.props;

    const userProps = {
      user: iqm,
      type: 'iqms',
      role,
      resource: 'iqm',
      editHandler: activeTab === TIME_OFF_TAB ? this.renderTimeOffEditButton() : null,
    };

    return (
      <ThemeProvider theme={detailsTheme}>
        <UserDetailsCard {...userProps} >
          <Tabs index={activeTab} onChange={onTabChange} className={RTTabs.absoluteTabs}>
            <Tab label="Basic Info">
              <UserDetailsBasicInfo user={iqm} leadCertField canDeliverField />
              <UserDetailsBadgeInfo user={iqm} />
              <UserDetailsRow title="IQM Details">
                <UserDetailsElement title="Workroom(s)" value={stringifyList(iqm.workrooms)} />
                <UserDetailsElement
                  title="Surface Types"
                  value={stringifyList(iqm.surface_types)}
                />
              </UserDetailsRow>
            </Tab>

            <Tab label="Time Off">
              <TimeOffTable isEditable={isEditable} ptos={ptos} parentID={iqm.id} parentKind="iqms" />
            </Tab>
          </Tabs>
        </UserDetailsCard>
      </ThemeProvider>
    );
  }
}

IQMDetailsCard.propTypes = {
  iqm: IQMType.isRequired,
  role: PropTypes.string,
  ptos: PropTypes.arrayOf(PTOType),
  activeTab: PropTypes.number,
  onTabChange: PropTypes.func,
  user: RoleType,
};

export default IQMDetailsCard;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/iqms/components/IQMDetailsCard.jsx